import React, { Component } from 'react';
import { Button, message } from 'antd';
import intl from 'react-intl-universal';
import { getReportPdf } from '../../api/ownerReporting';
import OwnerPayoutCardView from '../../components/OwnerPayoutCardView';

class PayoutV2Card extends Component {
  constructor(props) {
    super(props);
    this.state = { pdfLoading: false };
  }

  onInvoice = async () => {
    const { hostId, card } = this.props;
    if (!card || card.auditStatus !== 'audited') {
      return;
    }
    this.setState({ pdfLoading: true });
    const hide = message.loading('Generating PDF…', 0);
    try {
      const result = await getReportPdf(hostId, {
        unitId: card.unitId,
        year: card.year,
        month: card.month,
      });
      if (!result || !result.blob) {
        throw new Error('Empty PDF response');
      }
      const url = URL.createObjectURL(result.blob);
      const opened = window.open(url, '_blank');
      if (!opened) {
        const a = document.createElement('a');
        a.href = url;
        a.download = result.filename || 'owner-report.pdf';
        document.body.appendChild(a);
        a.click();
        a.remove();
      }
      setTimeout(() => URL.revokeObjectURL(url), 60000);
    } catch (e) {
      message.error((e && e.message) || 'PDF download failed');
    } finally {
      hide();
      this.setState({ pdfLoading: false });
    }
  };

  render() {
    const { card, shouldShowEarning } = this.props;
    const { pdfLoading } = this.state;
    return (
      <OwnerPayoutCardView
        card={card}
        shouldShowEarning={shouldShowEarning}
        invoice={
          <Button type="primary" loading={pdfLoading} disabled={card.auditStatus !== 'audited'} onClick={this.onInvoice}>
            {intl.get('payout.headerLabels.invoicePayout').d('Invoice Payout')}
          </Button>
        }
      />
    );
  }
}

export default PayoutV2Card;
